import React from "react";
import { Download } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChatArtifact } from "./ChatArtifact";
import { DocumentArtifact } from "@/lib/documentConverter";

interface ChatDownloadsPanelProps {
  artifacts: DocumentArtifact[];
  title?: string;
}

export const ChatDownloadsPanel: React.FC<ChatDownloadsPanelProps> = ({
  artifacts,
  title = "Downloads",
}) => {
  if (artifacts.length === 0) {
    return (
      <div className="p-4 h-full flex flex-col items-center justify-center text-center">
        <Download className="h-8 w-8 text-muted-foreground/50 mb-2" />
        <p className="text-sm text-muted-foreground">
          No downloads yet
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          Ask Claude to create documents
        </p>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b border-border">
        <h3 className="font-semibold flex items-center gap-2">
          <Download className="h-4 w-4" />
          {title}
        </h3>
        <p className="text-xs text-muted-foreground mt-1">
          {artifacts.length} file{artifacts.length !== 1 ? "s" : ""}
        </p>
      </div>
      <ScrollArea className="flex-1 p-4">
        <div className="space-y-2">
          {artifacts.map((artifact, idx) => (
            <ChatArtifact key={idx} artifact={artifact} />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};
